

<div style="height: 100%;">
  <div class="welcome-container">
  <div id="welcomeImgDesktop" class="onboarding-container" style="background-image: url('{{welcomeImageUrl}}') !important;">
    <ng-container *ngTemplateOutlet="welcomeBodyContent"></ng-container>
  </div>
  <div id="welcomeImgMobile" class="onboarding-container" style="background-image: url('{{welcomeMobileImageUrl}}') !important;">
    <ng-container *ngTemplateOutlet="welcomeBodyContent"></ng-container>
  </div>
</div>

  <ng-template #welcomeBodyContent>
    <div class="body-container">
      <div class="header bold header-container">
        <h1 class="title-container"><adp-label labelKey="Onboarding_Diagnostic_Landing_Header"></adp-label></h1>
      </div>

      <div class="body">
        <p class="subtitle-container"><adp-label labelKey="Onboarding_Diagnostic_Landing_Subheader"></adp-label></p>
        <p class="content-container">
          <adp-label labelKey="Onboarding_Diagnostic_Landing_Description_Part1"></adp-label>
        </p>
      </div>
      <div modal-footer class="row" style="padding-top:25px;">
        <div class="col-12 col-sm-6 mb-10" *ngIf="isOnboardingFlow">
          <button onfocus="blur();" style="border-radius: 6px !important;" mat-stroked-button color="primary" (click)="skipTest()" class="border-0"><adp-label labelKey="Onboarding_Diagnostic_Landing_Button_SkipTest"></adp-label></button>
        </div>
        <div class="col-12 col-sm-6 button-container-mobile">
          <button style="border-radius: 6px !important;" mat-flat-button color="accent" (click)="next()"><adp-label labelKey="Onboarding_Diagnostic_Landing_Button_GetStarted"></adp-label></button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #infoIcon>

    <svg width="24" height="24" viewBox="0 0 24 24" title="info icon" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2585_54571)">
      <path d="M13 15.5C12.1727 15.5 11.5 14.8273 11.5 14V11.5H11C10.724 11.5 10.5 11.276 10.5 11C10.5 10.724 10.724 10.5 11 10.5H11.5C12.0513 10.5 12.5 10.9487 12.5 11.5V14C12.5 14.276 12.724 14.5 13 14.5H13.5C13.776 14.5 14 14.724 14 15C14 15.276 13.776 15.5 13.5 15.5H13Z" fill="currentColor"/>
      <path d="M11.75 9.5C12.1642 9.5 12.5 9.16421 12.5 8.75C12.5 8.33579 12.1642 8 11.75 8C11.3358 8 11 8.33579 11 8.75C11 9.16421 11.3358 9.5 11.75 9.5Z" fill="currentColor"/>
      <path d="M12 20C7.58867 20 4 16.4113 4 12C4 7.58867 7.58867 4 12 4C16.4113 4 20 7.58867 20 12C20 16.4113 16.4113 20 12 20ZM12 5C8.14 5 5 8.14 5 12C5 15.86 8.14 19 12 19C15.86 19 19 15.86 19 12C19 8.14 15.86 5 12 5Z" fill="currentColor"/>
      </g>
      <defs>
      <clipPath id="clip0_2585_54571">
      <rect width="16" height="16" fill="white" transform="translate(4 4)"/>
      </clipPath>
      </defs>
      </svg>

      </ng-template>
</div>

